export default __webpack_public_path__ + "static/media/2-Ano-04-Sem-Pressa.1329c85c.png";